import { combineReducers } from 'redux';

import * as actionTypes from 'modules/audits/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import data from './data';
import type { AuditAssignmentByAuditId } from './data';

export type AuditsUIDetailsAssignmentReducer = {
  data: AuditAssignmentByAuditId;
  loading: boolean;
};

export default combineReducers({
  data,
  loading: loading(actionTypes.PATCH_ASSIGNEES_REQUEST),
});
